import { Grid } from "@mui/material";
import MDTypography from "components/Basics/MDTypography";
import EditorHtml from "components/Custom/EditorHtml/EditorHtml";

const InputHtml = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "100%",
				minWidth: "100%"
			}}
		>
			<MDTypography variant="caption" fontWeight="bold">
				{label}
			</MDTypography>
			<EditorHtml
				dictionary={{}}
				onSetHtml={(html, json) => {
					onChange(html);
				}}
				value={value}
			/>
		</Grid>
	);
};
export default InputHtml;
